import script from "./DynamicPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicPage.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicPage.vue?vue&type=style&index=0&id=09140831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09140831"]])

export default __exports__